import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	label: {
		id: 'eoc.escalation-modal.form.label.no-translate',
		defaultMessage: 'Team',
		description: 'Label of team field.',
	},
	placeholder: {
		id: 'eoc.escalation-modal.form.placeholder.no-translate',
		defaultMessage: 'Search for a team',
		description: 'Label of team field.',
	},
});

export default messages;
